import { render, staticRenderFns } from "./ProductoInventario.vue?vue&type=template&id=13de9392&"
import script from "./ProductoInventario.vue?vue&type=script&lang=js&"
export * from "./ProductoInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports